import { render, staticRenderFns } from "./TableStockout.vue?vue&type=template&id=ab5cdf8a&scoped=true&"
import script from "./TableStockout.vue?vue&type=script&lang=js&"
export * from "./TableStockout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5cdf8a",
  null
  
)

export default component.exports